export const Icons = ['amazon', 'azure', 'wasabi', 'backblaze', 'minio', 's3compatible', 'local', 'cloud'];
